import { useMutation, useQueryClient } from '@tanstack/react-query'

import { queryKey as queryKeyGeblokkeerdeWekenForEntity } from '../../entity/planning/hooks/useGeblokkeerdeWekenForEntity'
import { queryKey as queryKeyHerplanGeblokkeerdeWeken } from '../../hoofdleiding/project/hooks/useHerplanGeblokkeerdeWeken'
import { useAlerts } from '../../theme/hooks/useAlerts'
import { queryKey as queryKeyGeblokkeerdeWekenSearch } from '../hooks/useGeblokkeerdeWekenSearch'
import { patchGeblokkeerdeWeek } from '../services/patchGeblokkeerdeWeek'

export { useUpdateGeblokkeerdeWeek }

const useUpdateGeblokkeerdeWeek = () => {
  const queryClient = useQueryClient()
  const { successAlert, errorAlert } = useAlerts()

  return useMutation({
    mutationFn: patchGeblokkeerdeWeek,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [queryKeyGeblokkeerdeWekenSearch],
      })
      queryClient.invalidateQueries({
        queryKey: [queryKeyHerplanGeblokkeerdeWeken],
      })
      queryClient.invalidateQueries({
        queryKey: [queryKeyGeblokkeerdeWekenForEntity],
      })
      successAlert('Geblokkeerde week successvol opgeslagen')
    },
    onError: (error: any) => {
      errorAlert('Fout bij wijzigen geblokkeerde week', error)
    },
  })
}
